<form [ngrxFormState]="form" *ngIf="form$|async; let form" class="w-100" autocomplete="off" role="presentation">
    <div class="content">
        <div class="row">
            <div class="col col-md-12 p-0">

                <div class="col-12 p-0">

                    <div class="privacy">
                        <p>
                            I have received all the information I require in order to exercise the choices I have made.
                            All the details I have provided in this application form are true and correct. I have made
                            an informed decision because I have read the <a
                                href="https://vervesuper.com.au/docs/product-disclosure-statement"
                                target="_blank">Product Disclosure Statement</a>, <a
                                href="http://vervesuper.com.au/docs/target-market-determination" target="_blank">Target
                                Market
                                Determination</a>, <a href="http://vervesuper.com.au/docs/how-verve-super-works-guide"
                                target="_blank">How Verve Super Works Guide</a>, <a
                                href="http://vervesuper.com.au/docs/insurance-guide" target="_blank">Insurance Guide</a>
                            and <a href="http://vervesuper.com.au/docs/financial-services-guide"
                                target="_blank">Financial Services Guide</a> to
                            which this application applies.
                        </p>
                        <p>
                            I accept that I will be bound by the provisions of the Trust Deed and rules which govern the
                            operations of Verve Super.
                        </p>
                        <p>
                            I acknowledge that no representations have been made to me by or on behalf of Verve Super
                            other than those contained in the Product Disclosure Statement and associated documents.
                        </p>
                        <p>
                            I have chosen an investment option(s) and I understand the nature of the risks attached to
                            the investments I am applying for. I acknowledge that neither Verve Super, nor the Trustee
                            of the Fund, guarantee a return of capital or the performance of my investment.
                        </p>
                        <app-checkbox class="entry-dark-bg" title="I have read, understood and agree to the above"
                            [control]="
                                      form.controls.readAllInformationAgreement
                                    ">
                        </app-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-bottom d-flex d-flex flex-row justify-content-between mt-3 mb-4 col-12 p-0">
        <app-button class="back-btn" title="Back" color="light" icon="west" [isDisabled]="(isLoading$ | async)" (onClick)="onMoveBackClick()">
        </app-button>
        <app-button class="custom" title="I agree" (onClick)="onMoveNextClick()" loading icon="east"
            [isDisabled]="(isLoading$ | async) || form.isInvalid">
        </app-button>
    </div>
    <div class="footer footer-mobile col-12 mt-5 p-0">
        <ng-template class="" [ngTemplateOutlet]="FooterStep3"></ng-template>
    </div>
</form>

<ng-template #FooterStep3>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>